/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import ContactChannels from "src/app/components/ContactChannels/ContactChannels";
import ChatBot from "src/app/components/ChatBot";
import WithLoader from "src/app/components/WithLoader";
import GetInTouchInfoMessage from "src/app/components/GetInTouchInfoMessage";
import noticeError from "src/app/utilities/noticeError";
import { useSelector } from "react-redux";

const NuanceChat = ({
  chatBotStatus,
  chatBotEnabled,
  channels,
  chatNowChannel,
  countryCode,
  isFeatureEnabled,
  loadNuanceChat,
  outOfHours,
  setChatBotStatus,
  storeData,
}) => {
  const [emailEnabled, setEmailEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [liveChatAvailable, setLiveChatAvailable] = useState(false);

  const { chatBotMinimised } = useSelector((state) => state.getInTouch);

  const isLoading = loading || chatBotStatus === "loading";
  const chatBotActive = chatBotStatus === "chatactive";
  const isOutOfHours = outOfHours && outOfHours !== false;
  const renderChatBot = chatBotEnabled && !isOutOfHours;
  const openingTimes = outOfHours?.nextOpeningHour || "";

  const handleChatBotStatusChange = (status) => {
    setChatBotStatus(status);
  };

  useEffect(() => {
    async function load() {
      try {
        const emailEnabled = await isFeatureEnabled(
          "cchp-show-send-us-an-email"
        );

        setLiveChatAvailable(!isOutOfHours);
        setEmailEnabled(emailEnabled);
        setLoading(false);
      } catch (error) {
        noticeError(error);
      }
    }

    load();
  }, [chatBotStatus, outOfHours, isFeatureEnabled]);

  return (
    <WithLoader loading={isLoading} style={{ height: "calc(100% - 12px)" }}>
      <>
        {!liveChatAvailable && (
          <GetInTouchInfoMessage
            openingTimes={openingTimes}
            outOfHours={isOutOfHours}
            countryCode={countryCode}
          />
        )}

        {renderChatBot && (
          <ChatBot
            isActive={chatBotActive}
            isMinimised={chatBotMinimised}
            onStatusChange={handleChatBotStatusChange}
            status={chatBotStatus}
            shouldTrack={loadNuanceChat}
          />
        )}
        {!chatBotEnabled && (
          <ul>
            <ContactChannels
              chatNow={chatNowChannel}
              channels={channels}
              storeData={storeData}
              liveChatAvailable={liveChatAvailable}
              showEmailButton={emailEnabled}
            />
          </ul>
        )}
      </>
    </WithLoader>
  );
};

NuanceChat.propTypes = {
  chatBotStatus: PropTypes.string,
  chatBotEnabled: PropTypes.bool,
  channels: PropTypes.array,
  chatNowChannel: PropTypes.object,
  countryCode: PropTypes.string,
  isFeatureEnabled: PropTypes.func,
  loadNuanceChat: PropTypes.bool,
  outOfHours: PropTypes.bool || PropTypes.object,
  setChatBotStatus: PropTypes.func,
  storeData: PropTypes.object,
};

export default NuanceChat;
